import { useQuery } from "@tanstack/react-query";
import { useProductionService } from "../services/production";
import type { PerformanceQuery } from "@/shared/types/production";

export function useProductionPerformance(query: PerformanceQuery) {
  const service = useProductionService();
  return useQuery({
    queryKey: ["production-performance", query.fromMs, query.toMs],
    queryFn: () => service.getPerformance(query),
    staleTime: 2 * 60_000,       // 2 min
    refetchInterval: 10 * 60_000, // 10 min
  });
}
